import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { ModalFullscreen } from '@cian/ui-kit';
import * as React from 'react';
import { NewbuildingCarousel } from '@cian/frontend-newbuilding-carousel-component';
import { throttle } from 'throttle-debounce';
import { getCurrentOptions } from '../../shared/helpers';
import { withoutBodyOverflow } from '../../shared/helpers/withBodyOverflow';
import { prepareSliderOptions, prepareSlides } from '../../shared/mappers';
import { ECounterPosition } from '../../shared/types';
import { Footer } from './parts/Footer';
import { Header } from './parts/Header';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FullscreenCarouselComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(FullscreenCarouselComponent, _React$Component);
  var _super = _createSuper(FullscreenCarouselComponent);
  function FullscreenCarouselComponent() {
    var _this;
    _classCallCheck(this, FullscreenCarouselComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({
      currentSlide: _this.props.defaultCurrentSlide || 1,
      options: getCurrentOptions(window.innerWidth, _this.props.media)
    }, prepareSlides(_this.props.slides, _this.props.defaultCurrentSlide)));
    _defineProperty(_assertThisInitialized(_this), "onSlideChange", function (params) {
      var onSlideChange = _this.props.onSlideChange;
      var currentSlide = params.currentSlide;
      var _prepareSlides = prepareSlides(_this.props.slides, currentSlide),
        slides = _prepareSlides.slides;
      _this.setState(function () {
        return {
          currentSlide: currentSlide,
          slides: slides
        };
      });
      if (onSlideChange) {
        onSlideChange(params);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onThumbnailClick", function (index) {
      _this.setState(function () {
        return {
          currentSlide: index
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updateOptions", function () {
      var media = _this.props.media;
      _this.setState(function () {
        return {
          options: getCurrentOptions(window.innerWidth, media)
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onWindowResize", function () {
      _this.updateOptions();
    });
    _defineProperty(_assertThisInitialized(_this), "throttledResizeHandler", throttle(150, _this.onWindowResize));
    return _this;
  }
  _createClass(FullscreenCarouselComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.throttledResizeHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.throttledResizeHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        defaultCurrentSlide = _this$props.defaultCurrentSlide,
        slides = _this$props.slides,
        media = _this$props.media;
      if (defaultCurrentSlide !== undefined && defaultCurrentSlide !== prevProps.defaultCurrentSlide) {
        this.setState(function () {
          return {
            currentSlide: defaultCurrentSlide
          };
        });
      }
      if (slides !== prevProps.slides) {
        this.setState(function () {
          return _objectSpread({}, prepareSlides(slides, defaultCurrentSlide));
        });
      }
      if (media !== prevProps.media) {
        this.setState(function () {
          return {
            options: getCurrentOptions(window.innerWidth, media)
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var onClose = this.props.onClose;
      var _this$state = this.state,
        currentSlide = _this$state.currentSlide,
        slides = _this$state.slides,
        options = _this$state.options,
        thumbnails = _this$state.thumbnails;
      var _prepareSliderOptions = prepareSliderOptions(options),
        firstPaintOptions = _prepareSliderOptions.firstPaintOptions,
        media = _prepareSliderOptions.media;
      var counterPosition = options.counterPosition,
        contentOptions = options.contentOptions,
        hideThumbnails = options.hideThumbnails;
      return /*#__PURE__*/_jsx(ModalFullscreen, {
        open: true,
        theme: "black",
        onClose: onClose,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles['container'],
          children: [/*#__PURE__*/_jsx(Header, {
            counter: counterPosition === ECounterPosition.HEADER ? {
              current: currentSlide,
              total: slides.length
            } : undefined,
            contentOptions: contentOptions,
            onCloseButtonClick: onClose
          }), /*#__PURE__*/_jsx("div", {
            className: styles['slider'],
            children: /*#__PURE__*/_jsx(NewbuildingCarousel, {
              slides: slides,
              firstPaintOptions: firstPaintOptions,
              media: media,
              onSlideChange: this.onSlideChange,
              defaultCurrentSlide: currentSlide
            })
          }), /*#__PURE__*/_jsx(Footer, {
            contentOptions: contentOptions,
            thumbnails: hideThumbnails ? undefined : thumbnails,
            currentSlide: currentSlide,
            onThumbnailClick: this.onThumbnailClick
          })]
        })
      });
    }
  }]);
  return FullscreenCarouselComponent;
}(React.Component);
export var FullscreenCarousel = withoutBodyOverflow(FullscreenCarouselComponent, 'FullscreenCarousel');